/**
 * Overlay strategems (target art / flash on unit or drone): shared fade timing for
 * StrategemTargetAnimation and two-phase completion watchdogs.
 * Play-turn is sent immediately from targetStrategem.js (no artificial WS delay).
 */

export const OVERLAY_STRATEGEM_LEAD_MS = 50;

/** Extra ms after overlay total before client watchdog sends strategem-animation-complete. */
export const OVERLAY_STRATEGEM_COMPLETE_WATCHDOG_BUFFER_MS = 150;

/** Server auto-applies pending strategem if client never sends animation-complete (websocketHandler). */
export const STRATEGEM_EFFECT_SERVER_FALLBACK_MS = 1500;

/** @type {Record<number, { fadeMs: number, targetTypes: string[] }>} */
export const OVERLAY_STRATEGEMS = {
  60: { fadeMs: 480, targetTypes: ['unit'] },
  313: { fadeMs: 720, targetTypes: ['unit'] },
  314: { fadeMs: 480, targetTypes: ['unit'] },
  315: { fadeMs: 720, targetTypes: ['unit'] },
  341: { fadeMs: 480, targetTypes: ['unit', 'drone'] },
};

/**
 * @param {*} strategemId
 * @returns {{ fadeMs: number, targetTypes: string[] } | null}
 */
export function getOverlayStrategemConfig(strategemId) {
  const id = Number(strategemId);
  if (!Number.isFinite(id)) return null;
  return OVERLAY_STRATEGEMS[id] ?? null;
}

/**
 * @param {*} strategemId
 * @param {string} targetType
 */
export function isOverlayStrategem(strategemId, targetType) {
  const cfg = getOverlayStrategemConfig(strategemId);
  if (!cfg || targetType == null) return false;
  return cfg.targetTypes.includes(targetType);
}

/**
 * @param {*} strategemId
 */
export function overlayStrategemFadeMs(strategemId) {
  return getOverlayStrategemConfig(strategemId)?.fadeMs ?? 0;
}

/**
 * Lead-in + overlay fade (matches StrategemTargetAnimation timer chain).
 * @param {*} strategemId
 */
export function overlayStrategemTotalMs(strategemId) {
  const fade = overlayStrategemFadeMs(strategemId);
  return fade > 0 ? OVERLAY_STRATEGEM_LEAD_MS + fade : 0;
}

/**
 * Delay before watchdog may send strategem-animation-complete.
 * @param {*} strategemId
 */
export function overlayStrategemWatchdogDelayMs(strategemId) {
  const total = overlayStrategemTotalMs(strategemId);
  return total > 0 ? total + OVERLAY_STRATEGEM_COMPLETE_WATCHDOG_BUFFER_MS : 0;
}
